import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

/** Раздел шаблонов уведомлений: список и редактор. */
export function RestrictNotificationTemplates({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.AdminCompanyNotificationTemplates]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
